import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check, ArrowLeft } from "lucide-react";
import { paymentStatus, formatUsd } from "../lib/api";
import { useCart } from "../context/CartContext";
import { PAYMENT } from "../constants/testIds";

export default function PaymentSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState(null);
  const { clear } = useCart();

  useEffect(() => {
    if (!sessionId) return;
    let attempts = 0;
    const poll = async () => {
      try {
        const res = await paymentStatus(sessionId);
        setStatus(res);
        if (res.payment_status === "paid") {
          clear();
          return;
        }
      } catch {}
      if (++attempts < 20) setTimeout(poll, 2000);
    };
    poll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  const paid = status?.payment_status === "paid";

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 lg:px-16 py-24 text-center min-h-[60vh] flex flex-col items-center justify-center">
      <div className={`w-20 h-20 rounded-full flex items-center justify-center mb-6 ${paid ? "bg-[#8B9E7E]/10" : "bg-[#FDF3ED]"}`}>
        <Check className={`w-10 h-10 ${paid ? "text-[#8B9E7E]" : "text-[#B89B66]"}`} strokeWidth={1.5} />
      </div>
      <div className="eyebrow">{paid ? "Order Confirmed" : "Processing"}</div>
      <h1 data-testid={PAYMENT.successHeading} className="font-serif text-4xl sm:text-5xl mt-4">
        {paid ? "Thank you for your order" : "Confirming your payment…"}
      </h1>
      <p className="text-[#6B5757] mt-6 max-w-lg leading-relaxed">
        {paid
          ? "We've emailed your confirmation. Your ALTA system will arrive before your surgery date, in premium packaging."
          : "This usually takes a few seconds. Please hold on."}
      </p>
      {paid && status?.order_id && (
        <div data-testid={PAYMENT.successOrderId} className="mt-8 font-mono text-xs tracking-widest text-[#A08D8D]">
          ORDER · {status.order_id.slice(0, 8).toUpperCase()}
        </div>
      )}
      {paid && status?.amount && (
        <div className="font-serif text-2xl mt-4">Total {formatUsd(status.amount)}</div>
      )}
      <Link data-testid={PAYMENT.backHomeBtn} to="/" className="btn-primary inline-flex items-center gap-3 mt-10">
        <ArrowLeft className="w-4 h-4" /> Back to Home
      </Link>
    </div>
  );
}
